import React from 'react';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import LightbulbOutlinedIcon from '@mui/icons-material/LightbulbOutlined';
import SuggestionReportDialog from './SuggestionReportDialog';

export default function SuggestionReporter({ isAuthenticated, reporter, compact = false }) {
    const [open, setOpen] = React.useState(false);

    if (!isAuthenticated) {
        return null;
    }

    const trigger = compact ? (
        <Tooltip title="Verbesserung vorschlagen">
            <IconButton color="inherit" onClick={() => setOpen(true)}>
                <LightbulbOutlinedIcon />
            </IconButton>
        </Tooltip>
    ) : (
        <Button
            color="inherit"
            startIcon={<LightbulbOutlinedIcon />}
            onClick={() => setOpen(true)}
        >
            Verbesserung vorschlagen
        </Button>
    );

    return (
        <>
            {trigger}
            <SuggestionReportDialog open={open} onClose={() => setOpen(false)} reporter={reporter} />
        </>
    );
}
